import React from 'react';
import './Careers.css';

const Careers = () => {
  // Application form removed as requested

  const openPositions = [
    {
      title: 'Quality Assurance Manager',
      department: 'Quality Control',
      location: 'Gadag, Karnataka',
      type: 'Full-time',
      experience: '5+ years',
      description: 'Manage quality control processes, ensure compliance with international standards, and lead quality improvement initiatives.'
    },
    {
      title: 'Export Sales Executive',
      department: 'Sales & Marketing',
      location: 'Gadag, Karnataka',
      type: 'Full-time',
      experience: '3+ years',
      description: 'Handle international sales, maintain client relationships, and drive export business growth.'
    },
    {
      title: 'Production Supervisor',
      department: 'Production',
      location: 'Gadag, Karnataka',
      type: 'Full-time',
      experience: '4+ years',
      description: 'Oversee production operations, ensure efficiency, and maintain quality standards in processing.'
    },
    {
      title: 'Logistics Coordinator',
      department: 'Supply Chain',
      location: 'Gadag, Karnataka',
      type: 'Full-time',
      experience: '2+ years',
      description: 'Coordinate shipping, manage inventory, and ensure timely delivery of products to international clients.'
    }
  ];

  const benefits = [
    {
      icon: 'fa-graduation-cap',
      title: 'Learning & Development',
      description: 'Continuous learning opportunities and professional development programs'
    },
    {
      icon: 'fa-heart',
      title: 'Health & Wellness',
      description: 'Comprehensive health insurance and wellness programs for employees'
    },
    {
      icon: 'fa-balance-scale',
      title: 'Work-Life Balance',
      description: 'Flexible working hours and work-life balance initiatives'
    },
    {
      icon: 'fa-trophy',
      title: 'Recognition & Rewards',
      description: 'Performance-based recognition and competitive compensation packages'
    },
    {
      icon: 'fa-users',
      title: 'Team Environment',
      description: 'Collaborative and supportive team environment with experienced professionals'
    },
    {
      icon: 'fa-globe',
      title: 'Global Exposure',
      description: 'Opportunity to work with international clients and global business practices'
    }
  ];

  return (
    <div className="careers-page">
      {/* Hero Section */}
      <section className="careers-hero">
        <div className="hero-background"></div>
        <div className="hero-gradient"></div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1>Join Our <span>Team</span></h1>
              <p className="lead">
                Be part of a dynamic team that's shaping the future of peanut exports. 
                We're looking for passionate individuals who share our commitment to quality and excellence.
              </p>
            </div>
            <div className="hero-visual">
              <div className="careers-badges">
                <div className="badge-item">
                  <i className="fa fa-briefcase"></i>
                  <span>Growth Opportunities</span>
                </div>
                <div className="badge-item">
                  <i className="fa fa-users"></i>
                  <span>Collaborative Culture</span>
                </div>
                <div className="badge-item">
                  <i className="fa fa-handshake-o"></i>
                  <span>Global Impact</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Join Us */}
      <section className="section why-join-us">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-header text-center">
                <h2>Why Join S. V. Gadag Ginning Factory?</h2>
                <p className="lead">
                  We offer a challenging and rewarding work environment where you can grow your career 
                  while contributing to our mission of delivering quality products worldwide.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            {benefits.map((benefit, index) => (
              <div key={index} className="col-md-6 col-lg-4 mb-4">
                <div className="benefit-card">
                  <div className="benefit-icon">
                    <i className={`fa ${benefit.icon}`}></i>
                  </div>
                  <h4>{benefit.title}</h4>
                  <p>{benefit.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Open Positions */}
      <section className="section open-positions">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 className="text-center mb-5">Current Openings</h2>
            </div>
          </div>
          <div className="row">
            {openPositions.map((position, index) => (
              <div key={index} className="col-md-6 mb-4">
                <div className="position-card">
                  <div className="position-header">
                    <h3>{position.title}</h3>
                    <div className="position-meta">
                      <span className="department">{position.department}</span>
                      <span className="location">{position.location}</span>
                    </div>
                  </div>
                  <div className="position-details">
                    <div className="detail-item">
                      <i className="fa fa-briefcase"></i>
                      <span>{position.type}</span>
                    </div>
                    <div className="detail-item">
                      <i className="fa fa-clock-o"></i>
                      <span>{position.experience} experience</span>
                    </div>
                  </div>
                  <p className="position-description">{position.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Information */}
      <section className="section contact-info">
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <div className="contact-content">
                <h2>How to Apply</h2>
                <p className="lead">
                  Interested in joining our team? Send us your resume and cover letter, 
                  and we'll get back to you with opportunities that match your skills and interests.
                </p>
                
                <div className="application-steps">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="step-item">
                        <div className="step-number">1</div>
                        <h4>Send Your Resume</h4>
                        <p>Email your resume and cover letter to our HR team</p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="step-item">
                        <div className="step-number">2</div>
                        <h4>Initial Review</h4>
                        <p>We'll review your application and contact you if there's a match</p>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="step-item">
                        <div className="step-number">3</div>
                        <h4>Interview Process</h4>
                        <p>Phone/video interview followed by in-person meeting if applicable</p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="step-item">
                        <div className="step-number">4</div>
                        <h4>Job Offer</h4>
                        <p>Reference checks and final job offer with onboarding</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="col-md-4">
              <div className="career-info">
                <h3>Contact HR</h3>
                
                <div className="contact-item">
                  <i className="fa fa-envelope"></i>
                  <div>
                    <h4>Email</h4>
                    <p><a href="mailto:svgadag_12@yahoo.com">svgadag_12@yahoo.com</a></p>
                  </div>
                </div>
                
                <div className="contact-item">
                  <i className="fa fa-phone"></i>
                  <div>
                    <h4>Phone</h4>
                    <p><a href="tel:+919448165266">+91 944 816 5266</a></p>
                  </div>
                </div>
                
                <div className="info-section">
                  <h4>What We Look For</h4>
                  <ul>
                    <li>Passion for quality and excellence</li>
                    <li>Strong communication skills</li>
                    <li>Problem-solving abilities</li>
                    <li>Team player mentality</li>
                    <li>Willingness to learn and grow</li>
                    <li>Knowledge of peanut/agricultural industry (preferred)</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Company Culture */}
      <section className="section company-culture">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 className="text-center mb-5">Our Company Culture</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="culture-card">
                <div className="culture-icon">
                  <i className="fa fa-handshake"></i>
                </div>
                <h4>Integrity</h4>
                <p>We maintain the highest standards of honesty and ethical behavior in all our business dealings.</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="culture-card">
                <div className="culture-icon">
                  <i className="fa fa-star"></i>
                </div>
                <h4>Excellence</h4>
                <p>We strive for excellence in everything we do, continuously improving our processes and products.</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="culture-card">
                <div className="culture-icon">
                  <i className="fa fa-users"></i>
                </div>
                <h4>Collaboration</h4>
                <p>We believe in the power of teamwork and collaboration to achieve our common goals.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Careers;
